import { FC } from "react";
import { Modal } from "@monolith-forensics/monolith-ui";
import CreateSoftwareForm from "../Forms/CreateSoftwareForm";

interface CreateSoftwareModalProps {
  show: boolean;
  onClose: () => void;
  onSubmit: () => void;
  onCancel: () => void;
}

export const CreateSoftwareModal: FC<CreateSoftwareModalProps> = ({
  show,
  onClose,
  onSubmit,
  onCancel,
}) => {
  const handleSubmit = () => {
    onSubmit?.(); // Refetches queries in software section
    handleClose();
  };

  const handleClose = () => {
    onClose();
  };
  const handleCancel = () => {
    onCancel?.();
  };

  return (
    <Modal open={show} onClose={onClose}>
      <CreateSoftwareForm
        width={550}
        onSubmit={handleSubmit}
        onCancel={handleCancel}
      />
    </Modal>
  );
};
